﻿(function () {
  var PRINT_AGENT_URL = 'http://127.0.0.1:3210/api/tickets/print';
  var BUTTON_CLASS = 'kiosk-print-request-button';
  var isSubmitting = false;

  function isKioskMode() {
    return document.documentElement.classList.contains('kiosk-mode');
  }

  function toGid(resource, id) {
    if (id === undefined || id === null) return undefined;
    return 'gid://shopify/' + resource + '/' + id;
  }

  function buildPayload(cart) {
    return {
      cartToken: cart.token || undefined,
      currency: cart.currency,
      subtotalCents: cart.total_price,
      items: cart.items.map(function (item) {
        return {
          productId: toGid('Product', item.product_id),
          variantId: toGid('ProductVariant', item.variant_id),
          title: item.product_title || item.title,
          variantTitle: item.variant_title || undefined,
          sku: item.sku || undefined,
          quantity: item.quantity,
          unitPriceCents: item.price,
          lineTotalCents: item.line_price,
          properties: {
            _location:
              (item.properties && item.properties._location) ||
              undefined
          }
        };
      })
    };
  }

  function showMessage(container, text, kind) {
    var existing = container.querySelector('.kiosk-print-message');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className =
      'kiosk-print-message kiosk-print-message--' + kind;
    el.textContent = text;
    container.appendChild(el);
  }

  function setButtonState(button, state) {
    if (state === 'submitting') {
      button.disabled = true;
      button.textContent = 'PRINTING REQUEST...';
    } else {
      button.disabled = false;
      button.textContent = 'PRINT CARD REQUEST';
    }
  }

  function handlePrintClick(event) {
    var button = event.currentTarget;

    if (isSubmitting) return;

    isSubmitting = true;
    setButtonState(button, 'submitting');

    fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Unable to read cart');
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          showMessage(
            button.parentElement,
            'Your cart is empty.',
            'error'
          );
          setButtonState(button, 'idle');
          isSubmitting = false;
          return;
        }

        return fetch(PRINT_AGENT_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(buildPayload(cart))
        })
          .then(function (res) {
            return res.json().then(function (body) {
              return {
                ok: res.ok,
                body: body
              };
            });
          })
          .then(function (response) {
            var result = response.body;

            if (
              response.ok &&
              result.success === true &&
              result.clearCart === true
            ) {
              return fetch('/cart/clear.js', {
                method: 'POST'
              }).then(function (clearResponse) {
                if (!clearResponse.ok) {
                  throw new Error(
                    'Ticket printed but cart could not be cleared'
                  );
                }

                showMessage(
                  button.parentElement,
                  'Your request has been printed. Ticket ' +
                    result.ticketNumber +
                    '. Please bring it to the front counter.',
                  'success'
                );

                setTimeout(function () {
                  window.location.href = '/';
                }, 4000);
              });
            }

            console.error('[kiosk] print failed:', result);

            showMessage(
              button.parentElement,
              'We could not print your request. Please ask an employee for assistance. Your cart has not been cleared.',
              'error'
            );

            setButtonState(button, 'idle');
            isSubmitting = false;
          });
      })
      .catch(function (err) {
        console.error('[kiosk] print request error:', err);

        showMessage(
          button.parentElement,
          'We could not print your request. Please ask an employee for assistance. Your cart has not been cleared.',
          'error'
        );

        setButtonState(button, 'idle');
        isSubmitting = false;
      });
  }

  function createButton() {
    var button = document.createElement('button');

    button.type = 'button';
    button.className =
      BUTTON_CLASS +
      ' button button--full-width button--primary';
    button.textContent = 'PRINT CARD REQUEST';
    button.addEventListener('click', handlePrintClick);

    return button;
  }

  function injectNear(selector) {
    var target = document.querySelector(selector);

    if (!target || !target.parentElement) return;

    if (
      target.parentElement.querySelector(
        '.' + BUTTON_CLASS
      )
    ) {
      return;
    }

    target.parentElement.insertBefore(
      createButton(),
      target.nextSibling
    );
  }

  function injectAll() {
    if (!isKioskMode()) return;

    injectNear('#CartDrawer-Checkout');
    injectNear('#checkout');
  }

  function init() {
    if (!isKioskMode()) return;

    injectAll();

    new MutationObserver(injectAll).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();
